// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const SET_SELECTED_HOTEL = 'SET_SELECTED_HOTEL';
